import Utils from 'src/utils';
import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';

export const GET_TRACKING_COMPANY_REQUEST = 'GET_TRACKING_COMPANY_REQUEST';
export const GET_TRACKING_COMPANY_SUCCESS = 'GET_TRACKING_COMPANY_SUCCESS';
export const GET_TRACKING_COMPANY_FAIL = 'GET_TRACKING_COMPANY_FAIL';

export const GET_TRACKING_EVENTS_REQUEST = 'GET_TRACKING_EVENTS_REQUEST';
export const GET_TRACKING_EVENTS_SUCCESS = 'GET_TRACKING_EVENTS_SUCCESS';
export const GET_TRACKING_EVENTS_FAIL = 'GET_TRACKING_EVENTS_FAIL';

export const GET_TRACKING_EVENTS_TYPES_REQUEST = 'GET_TRACKING_EVENTS_TYPES_REQUEST';
export const GET_TRACKING_EVENTS_TYPES_SUCCESS = 'GET_TRACKING_EVENTS_TYPES_SUCCESS';
export const GET_TRACKING_EVENTS_TYPES_FAIL = 'GET_TRACKING_EVENTS_TYPES_FAIL';

export const RESET_TRACKING_COMPANY_PEOPLE_COUNT_REQUEST = 'RESET_TRACKING_COMPANY_PEOPLE_COUNT_REQUEST';
export const RESET_TRACKING_COMPANY_PEOPLE_COUNT_SUCCESS = 'RESET_TRACKING_COMPANY_PEOPLE_COUNT_SUCCESS';
export const RESET_TRACKING_COMPANY_PEOPLE_COUNT_FAIL = 'RESET_TRACKING_COMPANY_PEOPLE_COUNT_FAIL';

export const POST_LOCK_COMMAND_REQUEST = 'POST_LOCK_COMMAND_REQUEST';
export const POST_LOCK_COMMAND_SUCCESS = 'POST_LOCK_COMMAND_SUCCESS';
export const POST_LOCK_COMMAND_FAIL = 'POST_LOCK_COMMAND_FAIL';

const getTrackingCompanyRequest = () => ({ type: GET_TRACKING_COMPANY_REQUEST });
const getTrackingCompanySuccess = (payload) => ({ type: GET_TRACKING_COMPANY_SUCCESS, payload });
const getTrackingCompanyFail = () => ({ type: GET_TRACKING_COMPANY_FAIL });

const getTrackingEventsRequest = () => ({ type: GET_TRACKING_EVENTS_REQUEST });
const getTrackingEventsSuccess = (payload) => ({ type: GET_TRACKING_EVENTS_SUCCESS, payload });
const getTrackingEventsFail = () => ({ type: GET_TRACKING_EVENTS_FAIL });

const getTrackingEventsTypesRequest = () => ({ type: GET_TRACKING_EVENTS_TYPES_REQUEST });
const getTrackingEventsTypesSuccess = (payload) => ({ type: GET_TRACKING_EVENTS_TYPES_SUCCESS, payload });
const getTrackingEventsTypesFail = () => ({ type: GET_TRACKING_EVENTS_TYPES_FAIL });

const resetTrackingCompanyPeopleCountRequest = () => ({ type: RESET_TRACKING_COMPANY_PEOPLE_COUNT_REQUEST });
const resetTrackingCompanyPeopleCountSuccess = (payload) => ({ type: RESET_TRACKING_COMPANY_PEOPLE_COUNT_SUCCESS, payload });
const resetTrackingCompanyPeopleCountFail = () => ({ type: RESET_TRACKING_COMPANY_PEOPLE_COUNT_FAIL });

const postLockCommandRequest = () => ({ type: POST_LOCK_COMMAND_REQUEST });
const postLockCommandSuccess = () => ({ type: POST_LOCK_COMMAND_SUCCESS });
const postLockCommandFail = () => ({ type: POST_LOCK_COMMAND_FAIL });

export const postLockCommand = (params) => async (dispatch) => {
  dispatch(postLockCommandRequest());
  try {
    const { data } = await communicate({ url: 'Argos/Locks/ChangeState', getParams: Utils.objects.getQueryStringFromObject(params) });
    if (data.Success) {
      dispatch(postLockCommandSuccess());
      toastrSuccess(data);
    } else {
      dispatch(postLockCommandFail());
      await toastrError({ message: data.ResultMsg });
    }
  } catch (err) {
    dispatch(postLockCommandFail());
    await toastrError(err);
  }
};

export const getTrackingCompany = (companyIds) => async (dispatch) => {
  dispatch(getTrackingCompanyRequest());
  try {
    const res = await communicate({
      url: 'TrackingFloorPlans',
      getParams: Utils.objects.getQueryStringFromObject({ companyIds })
    });
    dispatch(getTrackingCompanySuccess(res.data.Data));
  } catch (err) {
    dispatch(getTrackingCompanyFail());
    await toastrError(err);
  }
};

export const getTrackingEvents = () => async (dispatch) => {
  dispatch(getTrackingEventsRequest());
  try {
    const res = await communicate({ url: 'TrackingEvents' });
    dispatch(getTrackingEventsSuccess(res.data.Data));
  } catch (err) {
    dispatch(getTrackingEventsFail());
    await toastrError(err);
  }
};

export const getTrackingEventsTypes = () => async (dispatch) => {
  dispatch(getTrackingEventsTypesRequest());
  try {
    const res = await communicate({ url: 'TrackingEvents/Types' });
    dispatch(getTrackingEventsTypesSuccess(res.data.Data));
  } catch (err) {
    dispatch(getTrackingEventsTypesFail());
    await toastrError(err);
  }
};

export const resetTrackingCompanyPeopleCount = (Ids, companyIds) => async (dispatch) => {
  dispatch(resetTrackingCompanyPeopleCountRequest());
  try {
    await communicate({
      url: 'TrackingRoomData/SetAsEmpty',
      getParams: Utils.objects.getQueryStringFromObject({ Ids })
    });
    await dispatch(getTrackingCompany(companyIds));
    dispatch(resetTrackingCompanyPeopleCountSuccess());
  } catch (err) {
    dispatch(resetTrackingCompanyPeopleCountFail());
    await toastrError(err);
  }
};
